import Axios from 'axios';
import { getHeaders } from '../../utills';
import AlertAction from '../Actions/AlertActions';
import GeneralAction from '../Actions/GeneralAction';
import WorkOrderRequestActions from '../Actions/WorkOrderRequestActions';
import Apis from '../Apis';


class WorkOrderRequestMiddleware {

  static getWorkOrderRequestCustomers = (userData) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.search) {
            dispatch(WorkOrderRequestActions.clearWorkOrderRequestCustomers())
          }
          let formdata = new FormData()
          formdata.append('name', userData?.search)
          const { data } = await Axios.post(
            Apis.workRequestCustomers,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(WorkOrderRequestActions.getWorkOrderRequestCustomers(data?.data))
            dispatch(GeneralAction.HideLoading())
     
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static getWorkOrderRequestCustomerDetails = (userData) => {

    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.search) {
            dispatch(WorkOrderRequestActions.clearWorkOrderRequestList())
          }
          const formData = new FormData();
          if (userData?.search) {
            formData.append('name', userData?.search)
          }
          const { data } = await Axios.post(
           Apis.workRequests + `${userData?.id}`,
            formData,
            {
              headers: getHeaders()
            }
          );

          if (data?.success) {
            dispatch(WorkOrderRequestActions.getWorkOrderRequestList(data?.data))
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  
  static declineWorkRequest = (id) => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading())
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('id', id)
          const { data } = await Axios.post(
            Apis.declineWorkRequest,
            formdata,
            {
              headers: getHeaders()
            }
          );

          if (data?.success) {
            resolve(data)
            console.log('SUCESSSSSSSS', data)
            dispatch(GeneralAction.HideLoading())
          } else {
            dispatch(GeneralAction.HideLoading())
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading())
        }
      });
    };
  }

  static CreateJob = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('category_id', userData?.SelectedCategory);
          formdata.append('date', userData?.SelectedDate);
          formdata.append('start_time', userData?.StartTime);
          formdata.append('end_time', userData?.EndTime);
          if (userData?.StoreID) {
            formdata.append('store_id', userData?.StoreID)
          }
          formdata.append('urgency', userData?.SelectedUrgency);
          if (userData?.LocationID) {
            formdata.append('store_address_id', userData?.LocationID)
          }
          formdata.append('service_name', userData?.ServiceName);
          formdata.append('details', userData?.ServiceDetails);
          formdata.append('address_id', userData?.selectedLocation);
          if(userData?.SelectedInventory?.length > 0){
          for (const [i, document] of userData?.SelectedInventory.entries()) {
            formdata.append(`inventories[${i}][inventory_id]`, document?.id);
            formdata.append(`inventories[${i}][quantity]`, document?.quantity);
          }}
          const { data } = await Axios.post(
            Apis.workRequestsCreate,
            formdata,
            {
              headers: getHeaders()
            },
          );
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
            // Alert.alert('Note', data?.message)
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

}

export default WorkOrderRequestMiddleware;